import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import { getInjectionMoldingModelData } from 'src/services/injectionMolding.services'

import { v4 as uuidv4 } from 'uuid'

const initialState = {
  modelData: {
    primary: {
      input_description: null,
      gravity_and_density: null,
      raw_material: null,
      unit_price: null,
      scrap_rate: null,
      length: null,
      width: null,
      thickness: null,
      height: null,
      raw_material_handling_fees: null,
      gravity_and_density_unit: null,
      length_unit: null,
      width_unit: null,
      height_unit: null,
      thickness_unit: null,
    },
    other: [
      {
        input_description: null,
        gravity_and_density: null,
        raw_material: null,
        unit_price: null,
        scrap_rate: null,
        length: null,
        width: null,
        thickness: null,
        height: null,
        gravity_and_density_unit: null,
        raw_material_handling_fees: null,
        length_unit: null,
        width_unit: null,
        height_unit: null,
        thickness_unit: null,
      },
    ],
    purchased_parts: [
      {
        part_number: null,
        part_description: null,
        part_quantity: null,
        unit_price: null,
        parts_handling_fee: null,
      },
    ],
    conversion: {
      press: {
        machine_hourly_rate: null,
        cycle_time: null,
        labor_quantity: null,
        labor_rate: null,
        process_scrap_rate: null,
      },
      painting: {
        machine_hourly_rate: null,
        cycle_time: null,
        labor_quantity: null,
        labor_rate: null,
        process_scrap_rate: null,
      },
      plating: {
        machine_hourly_rate: null,
        cycle_time: null,
        labor_quantity: null,
        labor_rate: null,
        process_scrap_rate: null,
      },
      assembly: {
        machine_hourly_rate: null,
        cycle_time: null,
        labor_quantity: null,
        labor_rate: null,
        process_scrap_rate: null,
      },
      country: null,
    },
    mark_up: {
      sg_and_a: null,
      profit: null,
      material_handling: null,
    },
    packaging: {
      type: null,
      dimensions: null,
      density: null,
      cost: null,
    },
    isDraft: true,
  },
  modelDataLoader: false,
  modelDataError: '',
  activeTab: 1,

}

export const injectionMoldingModelData = createSlice({
  name: 'get-injection-molding-model-data',
  initialState,
  reducers: {
    setPurchasedParts: (state, action) => {
      state.modelData = { ...state.modelData, purchased_parts: action.payload }
      
    },

    setMarkUp: (state, action) => {
      state.modelData = { ...state.modelData, mark_up: action.payload }
    },
    setPackaging: (state, action) => {
      state.modelData = { ...state.modelData, packaging: action.payload }
    },
    setActiveTab: (state, action) => {
      state.activeTab = action.payload
    },
    setConversion: (state, action) => {
      state.modelData = { ...state.modelData, conversion: action.payload }
    },
    setRawMaterial: (state, action) => {
      state.modelData = { ...state.modelData, ...action.payload }
    },
    updateModelData: (state, action) => {
      if (state.activeTab === 1) {
        state.modelData = { ...state.modelData, ...action.payload }
      } else {
        state.modelData = { ...state.modelData, [action.payload.key]: action.payload.value }
      }
    },
    resetModelData: () => initialState,
    handleBack: (state, action) => {
      if (state.activeTab === 1) {
        state.modelData = { ...state.modelData, ...action.payload }
      } else {
        state.modelData = { ...state.modelData, [action.payload.key]: action.payload.value }
      }
      state.activeTab = state.activeTab - 1
    },
    handleNext: (state, action) => {
      if (state.activeTab === 1) {
        state.modelData = { ...state.modelData, ...action.payload }
      } else {
        state.modelData = { ...state.modelData, [action.payload.key]: action.payload.value }
      }
      state.activeTab = state.activeTab + 1
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(getInjectionMoldingModelData.pending), (state) => {
      state.modelDataLoader = true
    })

    builder.addMatcher(isAnyOf(getInjectionMoldingModelData.fulfilled), (state, action) => {
      let model = { ...action.payload.data }
      Object.keys(model).forEach((dataModel) => {
        if (Array.isArray(model[dataModel])) {
          model[dataModel] = model[dataModel].map((field) => {
            return {
              id: uuidv4(),
              ...field,
            }
          })
        }
      })
      state.modelDataLoader = false
      state.modelData = model
    })

    builder.addMatcher(isAnyOf(getInjectionMoldingModelData.rejected), (state, action) => {
      state.modelDataLoader = false
      state.modelDataError = 'Failed to get model data!'
    })
  },
})
export const {
  setPurchasedParts,
  setMarkUp,
  resetModelData,
  setPackaging,
  updateModelData,
  setActiveTab,
  handleBack,
  handleNext,
  setConversion,
  setRawMaterial,
} = injectionMoldingModelData.actions
export default injectionMoldingModelData.reducer
